import { render, staticRenderFns } from "./presellInfo.vue?vue&type=template&id=3bf63d02&scoped=true"
import script from "./presellInfo.vue?vue&type=script&lang=js"
export * from "./presellInfo.vue?vue&type=script&lang=js"
import style0 from "./presellInfo.vue?vue&type=style&index=0&id=3bf63d02&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf63d02",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bf63d02')) {
      api.createRecord('3bf63d02', component.options)
    } else {
      api.reload('3bf63d02', component.options)
    }
    module.hot.accept("./presellInfo.vue?vue&type=template&id=3bf63d02&scoped=true", function () {
      api.rerender('3bf63d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/presell/presellInfo.vue"
export default component.exports